import React, { Component } from "react";
import Toggle from "react-toggle";
import "react-toggle/style.css";

class ChartsMetrics extends Component {
    renderMetrics = (list, preSelectedMetrics) => {
        if (list && list.length > 0) {
            return list.map((item, index) => (
                <div key={index} className="col-sm-4 mb-3">
                    <div className="d-flex align-items-center">
                        <span className="">
                            <Toggle
                                    icons={false}
                                    onChange={(e) => this.props.handleMetricsFilter(item.id, e)}
                                    name={item.id}
                                    value={item.id}
                                    id={item.id}
                                    checked={preSelectedMetrics.filter(matrix => matrix === item.id)[0] && preSelectedMetrics.filter(matrix => matrix === item.id)[0].length}
                            />
                        </span>
                        <span className="ml10 pr-2 latest-data-available text-ellipsis">{item.name}</span>
                    </div>
                </div>
            ));
        }
        return null;
    };
    render() {
        const { chartMetrices, searchObject } = this.props;
        return (
            <div>
                <div>
                    <div className="row">
                        <div className="col-sm-12 mb-3"><h4>Metrics</h4></div>
                    </div>
                    <div className="row">
                        {this.renderMetrics(chartMetrices, searchObject.metrics)}
                    </div>
                    <hr style={{ marginBottom: '10px' }} />
                </div>
            </div>
        );
    }
}

export default ChartsMetrics;
